import { render, staticRenderFns } from "./SmallDetailsOptions.vue?vue&type=template&id=1a222569"
import script from "./SmallDetailsOptions.vue?vue&type=script&lang=js"
export * from "./SmallDetailsOptions.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SmallDetailsOptions.vue?vue&type=style&index=0&id=1a222569&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports